// components/InstagramFeed.js
import { useEffect, useState } from 'react';
import Image from "next/image";

const InstagramFeed = ({ accessToken, userId }) => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch(
          `https://graph.instagram.com/${userId}/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token=${accessToken}`
        );
        const data = await response.json();
        //console.log(data.data);
        setPosts(data.data.slice(0, 5));
      } catch (error) {
        console.error('Error fetching Instagram posts', error);
      }
    };

    fetchPosts();
  }, [accessToken, userId]);

  return (
    <div>
      {/* {posts.map(post => (
        <div key={post.id}>
          <a href={post.permalink} target="_blank" rel="noopener noreferrer">
            {post.media_type === 'IMAGE' && <img src={post.media_url} alt={post.caption} />}
            {post.media_type === 'VIDEO' && <video controls src={post.media_url} />}
            {post.media_type === 'CAROUSEL_ALBUM' && post.thumbnail_url && <img src={post.thumbnail_url} alt={post.caption} />}
          </a>
          <p>{post.caption}</p>
        </div>
      ))} */}
      <div className="instagrid">
        {posts.map((post, index) => (
          <div className={`div${index+1}`} key={index}>
            <a className='position-relative d-block' href={post.permalink} target="_blank" rel="noopener noreferrer">
              {post.media_type === 'IMAGE' && 
              // <img src={post.media_url} alt="insta-images" />
              <Image src={post.media_url} alt="Album btn" width={1000} height={1000} />
              }
              {post.media_type === 'VIDEO' && 
              // <img src={post.thumbnail_url} alt="insta-images" />
              <Image src={post.thumbnail_url} alt="Album btn" width={1000} height={1000} />
              }
              {post.media_type === 'CAROUSEL_ALBUM' && post.media_url && 
              // <img src={post.media_url} alt="insta-images" />
              <Image src={post.media_url} alt="Album btn" width={1000} height={1000} />
              }
              {post.media_type === 'VIDEO' && 
              <div className='playbtn'>
                {/* <img  src="/play.png" alt="play btn" /> */}
                <Image src="/play.png" alt="Album btn" width={50} height={50} />
                </div>
                }
              {post.media_type === 'CAROUSEL_ALBUM' && 
              <div className='playbtn playbtnalum'>
                {/* <img  src="/images.png" alt="Album btn" /> */}
                <Image src="/images.png" alt="Album btn" width={50} height={50} />
                </div>
                }
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InstagramFeed;